import {
    Modal, Button, ModalHeader, ModalBody, ModalFooter, Badge,
} from 'appkit-react';

import '../styles/configWarningModal.scss';

const ConfigWarningModal = ({
    showWarningModal, setShowWarningModal, setConfirm,
}) => (
    <div className="true-comply__datarecon-configuration_warning_modal">
        <Modal
            className="action-modal-showcase"
            visible={showWarningModal}
            onCancel={() => setShowWarningModal(false)}
        >
            <ModalHeader>
                <div className="a-modal-example-header">
                    <div className="modal-title-left">
                        <Badge className="example-badge" type="warning">WARNING</Badge>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="true-comply__datarecon-dataconfiguration-reset_warning_modal_description">
                    There is already an existing configuration saved for this project. Do you want to proceed with this new configuration?
                    <div style={{
                        marginTop: '0.5rem', fontSize: '15px', color: 'red', fontWeight: 'lighter',
                    }}
                    >
                        *The current configuration will not be persisted unless manually saved.
                    </div>
                </div>
            </ModalBody>
            <ModalFooter className="a-apply-theme-border-top-gray-level-6">
                <div className="footer-comp">
                    <Button
                        kind="transparent"
                        gray
                        onClick={
                            () => {
                                setConfirm(false);
                                setShowWarningModal(false);
                            }
                        }
                        size="lg"
                    >
                        NO
                    </Button>
                    <Button
                        kind="transparent"
                        onClick={
                            () => {
                                setConfirm(true);
                                setShowWarningModal(false);
                            }
                        }
                        size="lg"
                    >
                        YES
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    </div>
);
export default ConfigWarningModal;
